<template>
  <div class="faqs">
    <h3>Apprenticeship Scheme</h3>
    <!-- Details -->
    <b-form-group>
      <label for="uniqueLearnerNumber"
        >Unique Learner Number (ULN) if known</label
      >
      <b-form-input
        id="uniqueLearnerNumber"
        :value="form.uniqueLearnerNumber"
        @input="handleInput('uniqueLearnerNumber', $event)"
        :class="{
          'is-valid':
            !$v.form.uniqueLearnerNumber.$error && form.uniqueLearnerNumber,
          'is-invalid': $v.form.uniqueLearnerNumber.$error,
        }"
      >
      </b-form-input>
    </b-form-group>
    <b-form-group>
      <label for="english"
        >Please attach your English GCSE Certificate here</label
      >
      <b-form-file
        id="english"
        @input="(e) => handleFileSelect(e, 'english')"
        v-model="$v.form.englishFileUpload.$model"
        :class="{
          'is-valid':
            !$v.form.englishFileUpload.$error && form.englishFileUpload,
          'is-invalid': $v.form.englishFileUpload.$error,
        }"
      >
      </b-form-file>
      <div
        v-if="
          form && !noEnglishCertificate && englishFilename && applicantId >= 0
        "
      >
        <a
          :href="`${filesServerUrl}/${applicantId}/files/english-certificate`"
          target="_blank"
          >{{ englishFilename }}
        </a>
      </div>
      <b-button
        class="mt-2"
        variant="primary"
        v-if="displayEnglishUploadBtn"
        @click="() => handleFileUpload('english')"
      >
        Upload English Certificate
      </b-button>
    </b-form-group>

    <b-form-group>
      <div class="checkbox checkbox-custom mb-3">
        <input
          id="no-english-cert"
          name="no-english-cert"
          type="checkbox"
          v-model="noEnglishCertificate"
          :value="form.noEnglishCertificate"
          @input="handleInput('noEnglishCertificate', $event.target.checked)"
        />
        <label for="no-english-cert">
          I do not have my English certificate
        </label>
      </div>
    </b-form-group>

    <b-form-group>
      <label for="maths">Please attach your Maths GCSE Certificate here</label>
      <b-form-file
        id="maths"
        v-model="$v.form.mathsFileUpload.$model"
        @input="(e) => handleFileSelect(e, 'maths')"
        :class="{
          'is-valid': !$v.form.mathsFileUpload.$error && form.mathsFileUpload,
          'is-invalid': $v.form.mathsFileUpload.$error,
        }"
      >
      </b-form-file>
      <div
        v-if="form && !noMathsCertificate && mathsFilename && applicantId >= 0"
      >
        <a
          :href="`${filesServerUrl}/${applicantId}/files/maths-certificate`"
          target="_blank"
          >{{ mathsFilename }}
        </a>
      </div>
      <b-button
        variant="primary"
        class="mt-2"
        v-if="displayMathsUploadBtn"
        @click="() => handleFileUpload('maths')"
      >
        Upload Maths Certificate
      </b-button>
    </b-form-group>

      <b-form-group>
        <div class="checkbox checkbox-custom">
          <input 
            id="no-maths-cert"
            name="no-maths-cert"
            type="checkbox"
            v-model="noMathsCertificate"
            :value="form.noMathsCertificate"
            @input="handleInput('noMathsCertificate', $event.target.checked)"
          >
          <label for="no-maths-cert">
            I do not have my Maths certificate
          </label>
        </div>
      </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
import { required } from 'vuelidate/lib/validators'
import { uploadEnglishCertificate, uploadMathsCertificate, getCertificateNames } from '../../services/api'

export default {
  computed: {
    ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.apprenticeship}),
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getToken: 'authStore/getToken',
    })
  },
  data () {
    return {
      formName: 'apprenticeship',
      englishFileUpload: null,
      mathsFileUpload: null,
      displayEnglishUploadBtn: false,
      displayMathsUploadBtn: false,
      noMathsCertificate: false,
      noEnglishCertificate: false,
      filesServerUrl: `${process.env.VUE_APP_RECRUITMENT_API}/admin/applicants`,
      applicantId: null,
      mathsFilename: "",
      englishFilename: "",
    };
  },
  mounted() {
    this.$v.$touch();
    setTimeout(() => {
      this.applicantId = this.getRecruit.applicantId;
      this.getCertificateData();
    }, 100);
  },
  updated() {
    // this.updateForm('valid', this.$v.$error)
    const validationData = {
      section: "apprenticeship",
      status: !this.$v.form.$invalid,
    };
    this.updateOnboardingCompleteAction(validationData);
  },
  methods: {
    ...mapActions({
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      setRecruitAction: 'authStore/setRecruitAction',
      updateOnboardingCompleteAction: 'authStore/updateOnboardingCompleteAction'
    }),
    async getCertificateData() {
      const certs = await getCertificateNames(this.getToken, this.applicantId);
      if (certs && certs.data && certs.data.length) {
        certs.data.forEach((cert) => {
          if (
            cert.type === "english-certificate" &&
            cert.file &&
            cert.file.filename
          ) {
            this.englishFilename = cert.file.filename;
          } else if (
            cert.type === "maths-certificate" &&
            cert.file &&
            cert.file.filename
          ) {
            this.mathsFilename = cert.file.filename;
          }
        });
      }
      const { apprenticeship } = this.getRecruit.onboarding.onboardingForms;
      this.noMathsCertificate = apprenticeship.noMathsCertificate;
      this.noEnglishCertificate = apprenticeship.noEnglishCertificate;
    },
    handleInput(input, e, nested, array, index, item) {
      this.updateForm(input, e, nested, array, index, item)
    },
    handleFileSelect (e, type) {
      if (e.name && type === 'english') {
        this.displayEnglishUploadBtn = true
      }
      if (e.name && type === 'maths') {
        this.displayMathsUploadBtn = true
      }
    },
    async handleFileUpload(type) {
      const formData = new FormData();
      let res;
      if (type === "english") {
        formData.append("englishFile", this.form.englishFileUpload);
        res = await uploadEnglishCertificate(this.getToken, formData);
        if (res && res.data && res.data.success && res.data.filename) {
          this.displayEnglishUploadBtn = false;
          this.englishFilename = res.data.filename;
        }
      }
      if (type === "maths") {
        formData.append("mathsFile", this.form.mathsFileUpload);
        res = await uploadMathsCertificate(this.getToken, formData);
        if (res && res.data && res.data.success && res.data.filename) {
          this.displayMathsUploadBtn = false;
          this.mathsFilename = res.data.filename;
        }
      }
    },
    updateForm
  },
  validations: {
    form: {
      uniqueLearnerNumber: {
        required: false
      },
      englishFileUpload: {
        required: required
      },
      mathsFileUpload: {
        required: required
      },
    },
  },
};
</script>

<style scoped>
.question-group {
  width: 100%;
  margin: 2rem 0;
}
.q-a {
  display: grid;
  grid-template-columns: 10% 90%;
}
.upload-text {
  margin-top: 10px;
  color: #76c95f;
}
</style>
